export default "__VITE_ASSET__DATl5bq1__"